import React, { useState } from "react";
import { useObserver } from "mobx-react-lite";
import { BaseModal } from "Components/Modal/BaseModal";
import { CancelButton } from "Globals/Styles/Control/Buttons";
import { Box, Button, Typography } from "@material-ui/core";
import { Cell, Grid } from "@shoothill/core";
import { DesignDataStatusViewModel } from "./DesignDataStatusViewModel";
import { ReportModalStyle } from "Views/Project/Modals/Modal.Styles";

interface ICreatedModalProps {
    open?: boolean;
    onClose(): void;
    onYes(): void;
    designDataId: string | null;
}

export const DesignDataStatusView: React.FC<ICreatedModalProps> = (props) => {
    const { open, onClose, onYes, designDataId } = props;
    const [viewModel] = useState(() => new DesignDataStatusViewModel(designDataId));
    const COLUMNS8 = "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr";

    const onYesClicked = () => {
        onYes();
    };

    return useObserver(() => (
        <BaseModal
            open={open}
            onClose={onClose}
            title={"Status change"}
            PaperComponent={ReportModalStyle}
            actions={
                <>
                    <Button onClick={onYesClicked} color="secondary" autoFocus variant="contained">
                        Yes
                    </Button>
                    <CancelButton onClick={onClose}>No</CancelButton>
                </>
            }
        >
            <Grid columnGap={30} rowGap={20} tc={COLUMNS8} dc={COLUMNS8} mb="35px">
                <Cell ts={8} ds={8}>
                    <Box>
                        <Typography style={{ margin: "17px 0px 13px" }} variant="h5">
                            Having changed this RDD to a status of with client, do you also want to add it to the client's tab?
                        </Typography>
                    </Box>
                </Cell>
            </Grid>
        </BaseModal>
    ));
};
